import React, { Component } from "react";
import { GetData } from "../../api/service";
import ResearchDescription from "./ResearchDescription";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

const NAVY    = "#1A2B4A";
const NAVY_2  = "#243B66";
const GOLD    = "#C8991A";
const CRIMSON = "#B22222";
const INK     = "#374151";
const BORDER  = "#e8e0d0";

class ResearchContainer extends Component {
  state = {
    link: "",
    data: [],
    isLoaded: false,
  };

  componentDidMount() {
    this.fetchDepartments();
    const link = this.props.match.params.link;
    if (link) {
      this.setState({ link });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.link !== this.props.match.params.link) {
      this.setState({ link: this.props.match.params.link });
    }
  }

  fetchDepartments = () => {
    GetData(`/getdepartments`).then((resp) => {
      this.setState(
        {
          data: resp,
          isLoaded: true,
        },
        () => {
          if (Array.isArray(this.state.data) && this.state.data.length > 0) {
            const link = this.props.match.params.link;
            if (!link) {
              this.setState({ link: this.state.data[0].dept_code });
            }
          }
        }
      );
    });
  };

  go = (dept_code) => {
    this.props.history.push(`/research/${dept_code}`);
  };

  render() {
    return (
      <div>
        <BreadCrumbOwn title="Research" />

        <div className="rs-page">
          <div className="rs-page__inner">
            {/* SIDEBAR */}
            <aside className="rs-side">
              <div className="rs-side__header">
                <span className="rs-side__eyebrow">Departments</span>
                <span className="rs-side__title">Research Areas</span>
              </div>

              <nav className="rs-side__nav" aria-label="Research departments">
                {this.state.data.map((el, index) => {
                  const active = el.dept_code === this.state.link;
                  return (
                    <button
                      type="button"
                      key={index}
                      onClick={() => this.go(el.dept_code)}
                      className={`rs-side__item${active ? " is-active" : ""}`}
                    >
                      <span>{el.dept_name}</span>
                    </button>
                  );
                })}
              </nav>
            </aside>

            {/* CONTENT */}
            <main className="rs-content">
              <div className="rs-content__body">
                <ResearchDescription
                  dept={this.state.data}
                  type={this.state.link}
                />
              </div>
            </main>
          </div>
        </div>

        <style>{`
          .rs-page {
            background: #fff;
            padding: 32px 0 56px;
          }
          .rs-page__inner {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
            display: grid;
            grid-template-columns: 280px 1fr;
            gap: 28px;
            align-items: start;
          }

          /* ── Sidebar ── */
          .rs-side {
            background: #fff;
            border: 1px solid ${BORDER};
            border-radius: 10px;
            box-shadow: 0 4px 18px rgba(26,43,74,0.06);
            overflow: hidden;
            position: sticky;
            top: 16px;
            max-height: calc(100vh - 32px);
            display: flex;
            flex-direction: column;
            font-family: 'Lato', sans-serif;
          }
          .rs-side__header {
            background: linear-gradient(135deg, ${NAVY} 0%, ${NAVY_2} 100%);
            color: #fff;
            padding: 18px 20px 16px;
            border-bottom: 3px solid ${GOLD};
            display: flex;
            flex-direction: column;
            gap: 4px;
          }
          .rs-side__eyebrow {
            color: ${GOLD};
            font-size: 10px;
            font-weight: 700;
            letter-spacing: 2px;
            text-transform: uppercase;
          }
          .rs-side__title {
            font-family: 'Playfair Display', Georgia, serif;
            font-size: 18px;
            font-weight: 700;
            letter-spacing: 0.3px;
          }
          .rs-side__nav {
            overflow-y: auto;
            padding: 6px 0;
            scrollbar-width: thin;
            scrollbar-color: ${GOLD} transparent;
          }
          .rs-side__nav::-webkit-scrollbar { width: 6px; }
          .rs-side__nav::-webkit-scrollbar-thumb {
            background: rgba(200,153,26,0.4);
            border-radius: 3px;
          }
          .rs-side__item {
            width: 100%;
            text-align: left;
            background: transparent;
            border: none;
            border-left: 3px solid transparent;
            padding: 10px 16px 10px 18px;
            font-family: 'Lato', sans-serif;
            font-size: 13.5px;
            font-weight: 500;
            color: ${INK};
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            transition: background 0.15s, color 0.15s, border-color 0.15s;
            line-height: 1.35;
          }
          .rs-side__item:hover {
            background: rgba(200,153,26,0.08);
            color: ${NAVY};
            border-left-color: ${GOLD};
          }
          .rs-side__item.is-active {
            background: rgba(178,34,34,0.06);
            color: ${CRIMSON};
            border-left-color: ${CRIMSON};
            font-weight: 700;
          }

          /* ── Content panel ── */
          .rs-content {
            background: #fff;
            min-width: 0;
          }
          .rs-content__body {
            padding: 8px 0 0 8px;
            color: ${INK};
            font-family: 'Lato', sans-serif;
          }

          @media (max-width: 960px) {
            .rs-page__inner {
              grid-template-columns: 1fr;
            }
            .rs-side {
              position: relative;
              top: 0;
              max-height: none;
            }
            .rs-side__nav {
              max-height: 320px;
            }
            .rs-content__body {
              padding: 8px 0 0 0;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default ResearchContainer;
